import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { HomeService } from '../../../services/home.service';
import { UtilService } from '../../../services/util.service';
import { RecaptchaServiceService } from '../../../services/recaptcha-service.service';
import { Order } from '../../../interfaces/order.interface';
import { OrderHistoryService } from '../../../services/order-history.service';

@Component({
  selector: 'app-input-order-finder',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './input-order-finder.component.html',
  styleUrl: './input-order-finder.component.css'
})
export class InputOrderFinderComponent implements OnInit {

  isDisabled = true;
  buttonColor = '#0095c8';
  orderNumber: string = "";
  orderNumberValid: boolean = true;
  isLoading = false;
  orderNumberSearched: string = "";
  orders: Order[] = [];
  itemsQuantity = 0;


  constructor(
    private router: Router,
    private _homeService: HomeService,
    private _utilService: UtilService,
    private _recaptchaService: RecaptchaServiceService,
    private _orderHistoryService: OrderHistoryService,
    private route: ActivatedRoute

  ) {

  }

  ngOnInit(): void {
    this.orderNumber = this._homeService.getOrderNumber();

    this.isDisabled = false;

    this._utilService.isLoading$.subscribe(status => {
      this.isLoading = status;
    });

    this._homeService.orders$.subscribe(orders => {
      this.orders = orders;

      const ordersHistory = this._orderHistoryService.getHistoryOrders();

      if (this.orders.length == 0 && ordersHistory.value.length == 0) {
        if (this.orderNumber != null && this.orderNumber.trim() != "") {
          this.orderNumberSearched = this.orderNumber;
          this.consultOrder(true);
        }
      }

      if (ordersHistory.value.length == 0) {
        this.itemsQuantity = orders.length;
      }

    });

    this.route.params.subscribe(params => {
      const id = params['id'];
      const externalOrderNumber = params['externalOrderNumber'];
      if (externalOrderNumber == undefined) {
        const orders = this._homeService.getOrders();
        this.itemsQuantity = orders.value.length;

      } else {
        this._orderHistoryService.getHistoryOrders();
        this._orderHistoryService.historyOrders$.subscribe(historyOrders => {

          const ordersFiltered: Order[] = historyOrders[externalOrderNumber] as Order[];
          if (ordersFiltered) this.itemsQuantity = ordersFiltered.length;

        })
      }

    });

  }

  valideButton() {
    if (this.orderNumberSearched.trim() == "") {
      this.isDisabled = false;
    } else {
      this.isDisabled = this._utilService.valideOrderNumber(this.orderNumberSearched);
    }
    this.orderNumberValid = true;
    this.toggleButtonState();
  }

  toggleButtonState() {
    this.isDisabled = !this.isDisabled;
    this.buttonColor = this.isDisabled ? '#cccccc' : '#0095c8';
  }

  consultOrder(empityValue: boolean = false) {
    if (this.orderNumberSearched.trim().length < 5 && !empityValue) return;

    this._recaptchaService.executeAction('ORDER_CHECK').subscribe(
      (token: string) => {
        this._homeService.captchaToken = token;

        this._utilService.setLoadingStatus(true);

        this._homeService.getWaybillStatus(this.orderNumberSearched)
          .subscribe({
            next: (dataResponse) => {
              if (dataResponse.code == 200) {
                this._homeService.setOrders(dataResponse);
                this._homeService.setOrderNumber(this.orderNumberSearched);
                this.orderNumber = this.orderNumberSearched;
                this.itemsQuantity = this._homeService.getOrders().value.length;

                this.orderNumberSearched = "";

                if (dataResponse.data.total > 0) {
                  this.orderNumberValid = true;
                  this.router.navigate(["/order-product-list"]);
                  setTimeout(() => {
                    this._utilService.setLoadingStatus(false);
                  }, 1000);
                } else {
                  this.orderNumberValid = false;
                  this._utilService.setLoadingStatus(false);
                }
              } else {
                this._utilService.setLoadingStatus(false);
              }
            },
            error: (error) => {
              console.error('Error al obtener los datos:', error);
              this._utilService.setLoadingStatus(false);
            }
          });

      },
      (error) => {
        console.error('Error al obtener el token de reCAPTCHA:', error);
      }
    );


  }

  onInput(event: Event) {
    this.valideButton();
  }

}
